module.exports = __webpack_public_path__ + "assets/img/ReadingOpinions.f2074209.png";